export default {
  SET_ENABLED(state, enabled) {
    state.enabled = enabled;
  },
  SET_SHORTCUTS(state, data) {
    state.shortcuts = data;
  },
};
